class ShopTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.selectTab(btn));
    });
  }

  selectTab(selectedBtn) {
    this.tabButtons.forEach((btn) => {
      const isSelected = btn === selectedBtn;
      btn.setAttribute('aria-selected', String(isSelected));
      btn.tabIndex = isSelected ? 0 : -1;
      const panel = this.querySelector('#' + CSS.escape(btn.getAttribute('aria-controls')));
      if (panel) panel.hidden = !isSelected;
    });
  }
}

customElements.define('shop-tabs', ShopTabs);
